import _regeneratorRuntime from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Logger } from '@ecom-alliance/libs';
import { creatorContactApiSensClient as creatorContactApiSensCmpClient } from '@/api/affiliate/serv/oec_affiliate_cmp_api_sens';
import { affiliateCreatorMarketPlaceApiClient, ContactInfoFieldType, ProfileType } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
import { creatorContactApiSensClient } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api_sens';
import { affiliateInvitationApiClient } from '@/api/affiliate/serv/oec_affiliate_invitation_api';
import { CREATORS_MAX_NUMBER, PRODUCTS_MAX_NUMBER } from '@/pages/find-creators/constants';
import { getProfileDataRequestParams } from './profile-formatter';
export var fetchCreatorContacts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(creatorId, shopId) {
    var _res$contact_info;
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return creatorContactApiSensCmpClient.GetCreatorContactInfo({
            creator_oecuid: creatorId,
            shop_id: shopId
          }).catch(function () {
            return {
              contact_info: []
            };
          });
        case 2:
          res = _context.sent;
          return _context.abrupt("return", (_res$contact_info = res === null || res === void 0 ? void 0 : res.contact_info) !== null && _res$contact_info !== void 0 ? _res$contact_info : []);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchCreatorContacts(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchCreatorProfile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(isNeedRequestV1, creatorId) {
    var _res$creator_profile, _res$creator_profile_, _res$creator_profile_2, _res$creator_profile_3, res, _res$data$segments$0$, _res$data, _res$data$segments, _res$data$segments$0$2, _res$data$segments$0$3, _res$data2, _res$data2$segments, _res$data2$segments$, _res$data2$segments$$, cardDataRequestParams, _res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (isNeedRequestV1) {
            _context2.next = 7;
            break;
          }
          _context2.next = 3;
          return affiliateCreatorMarketPlaceApiClient.GetCreatorProfile({
            creator_oec_id: creatorId,
            profile_types: [ProfileType.PROFILE_BASIC]
          });
        case 3:
          res = _context2.sent;
          return _context2.abrupt("return", [(_res$creator_profile = res.creator_profile) !== null && _res$creator_profile !== void 0 ? _res$creator_profile : {}, (_res$creator_profile_ = res.creator_profile_trend_data) === null || _res$creator_profile_ === void 0 ? void 0 : (_res$creator_profile_2 = _res$creator_profile_[0]) === null || _res$creator_profile_2 === void 0 ? void 0 : (_res$creator_profile_3 = _res$creator_profile_2.shop_invite_info) === null || _res$creator_profile_3 === void 0 ? void 0 : _res$creator_profile_3[creatorId], res.creator_connect_info]);
        case 7:
          cardDataRequestParams = getProfileDataRequestParams(creatorId);
          _context2.next = 10;
          return affiliateCreatorMarketPlaceApiClient.GetAffiliateCreatorProfileStatsQuery({
            request: cardDataRequestParams
          });
        case 10:
          _res = _context2.sent;
          return _context2.abrupt("return", [(_res$data$segments$0$ = (_res$data = _res.data) === null || _res$data === void 0 ? void 0 : (_res$data$segments = _res$data.segments) === null || _res$data$segments === void 0 ? void 0 : (_res$data$segments$0$2 = _res$data$segments[0].stats) === null || _res$data$segments$0$2 === void 0 ? void 0 : (_res$data$segments$0$3 = _res$data$segments$0$2[0]) === null || _res$data$segments$0$3 === void 0 ? void 0 : _res$data$segments$0$3.profile) !== null && _res$data$segments$0$ !== void 0 ? _res$data$segments$0$ : {}, (_res$data2 = _res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$segments = _res$data2.segments) === null || _res$data2$segments === void 0 ? void 0 : (_res$data2$segments$ = _res$data2$segments[0]) === null || _res$data2$segments$ === void 0 ? void 0 : (_res$data2$segments$$ = _res$data2$segments$.shop_invite_info) === null || _res$data2$segments$$ === void 0 ? void 0 : _res$data2$segments$$[creatorId], undefined]);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchCreatorProfile(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchSellerContact = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(region) {
    var res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return creatorContactApiSensClient.GetSellerContactInfo({
            country: region
          });
        case 2:
          res = _context3.sent;
          return _context3.abrupt("return", res.seller_contact_info);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchSellerContact(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
export var getTargetInvitationItemMaxNumber = function getTargetInvitationItemMaxNumber() {
  return affiliateInvitationApiClient.InvitationGroupInvitationLimit({}).then(function (res) {
    var _ref4 = res.data || {},
      _ref4$max_creator_num = _ref4.max_creator_num,
      max_creator_num = _ref4$max_creator_num === void 0 ? CREATORS_MAX_NUMBER : _ref4$max_creator_num,
      _ref4$max_product_num = _ref4.max_product_num,
      max_product_num = _ref4$max_product_num === void 0 ? PRODUCTS_MAX_NUMBER : _ref4$max_product_num;
    return {
      maxCreatorNumber: max_creator_num,
      maxProductNumber: max_product_num
    };
  }).catch(function (error) {
    Logger.error("getTargetInvitationMaxNumber failed.", "Server API: affiliateInvitationApiClient.InvitationGroupInvitationLimit", error);
    return {
      maxCreatorNumber: CREATORS_MAX_NUMBER,
      maxProductNumber: PRODUCTS_MAX_NUMBER
    };
  });
};
export var transformGeneralContactInfo2ContactType = function transformGeneralContactInfo2ContactType(contactInfoList, defaultCountryCode) {
  var contactTypeList = [];
  contactInfoList === null || contactInfoList === void 0 ? void 0 : contactInfoList.forEach(function (contact) {
    var _ref5 = contact || {},
      field = _ref5.field,
      country_code = _ref5.country_code,
      value = _ref5.value;
    var contactTypeItem = {
      value: value
    };
    if (ContactInfoFieldType.SELLER_INVITATION_EMAIL !== field) {
      contactTypeItem.countryCode = country_code || defaultCountryCode;
    }
    contactTypeList[field] = contactTypeItem;
  });
  return contactTypeList;
};
export var transformContactType2GeneralContactInfo = function transformContactType2GeneralContactInfo(contactTypeList, validateFieldsList) {
  var contactInfoList = [];
  contactTypeList === null || contactTypeList === void 0 ? void 0 : contactTypeList.forEach(function (item, field) {
    if (item && validateFieldsList !== null && validateFieldsList !== void 0 && validateFieldsList.includes(field)) {
      var _item$value = item.value,
        value = _item$value === void 0 ? '' : _item$value,
        countryCode = item.countryCode;
      contactInfoList.push({
        title: '',
        field: field,
        value: value,
        country_code: countryCode
      });
    }
  });
  return contactInfoList;
};